import { ShowAlert } from "@mirage/hooks/useAlertService";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { createContext, useContext } from "react";

const EntityTableContext = createContext({} as EntityTableContext);

export function useEntityTable() {
    return useContext(EntityTableContext);
}

export function EntityTableProvider({ children, value }: { children: React.ReactNode; value: EntityTableContext }) {
    return <EntityTableContext.Provider value={value}>{children}</EntityTableContext.Provider>;
}

interface EntityTableContext {
    setDateFilterPopper: React.Dispatch<React.SetStateAction<DateFieldPopper>>;
    dateFilterPopper: DateFieldPopper;
    apiRef: React.MutableRefObject<GridApiPremium>;
    showAlert: ShowAlert;
}

export interface DateFieldPopper {
    open: boolean;
    elementRef: HTMLDivElement | null;
    fieldName: string;
}
